export default __webpack_public_path__ + "static/media/logo.87fba766.png";